var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.848V9.06801C2 7.76683 3.05482 6.71201 4.356 6.71201H4.94501C5.68657 6.71201 6.38487 6.36286 6.82981 5.76961L9.44497 2.28272C9.57845 2.10475 9.78795 2 10.0104 2H17.5496C17.7722 2 17.9816 2.10475 18.1151 2.28272L20.7302 5.76961C21.1752 6.36286 21.8735 6.71201 22.615 6.71201H23.204C24.5053 6.71201 25.56 7.76683 25.56 9.06801V20.848C25.56 22.1493 24.5053 23.204 23.204 23.204H4.356C3.05482 23.204 2 22.1493 2 20.848Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7799 18.492C16.3822 18.492 18.4919 16.3823 18.4919 13.78C18.4919 11.1777 16.3822 9.06799 13.7799 9.06799C11.1775 9.06799 9.06787 11.1777 9.06787 13.78C9.06787 16.3823 11.1775 18.492 13.7799 18.492Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.64e6d33e1b9d120cf9bb0c7055677b77.svg";
export { ForwardRef as ReactComponent };